var map = {
	"./jsks/1.png": 8353,
	"./jsks/2.png": 8186,
	"./jsks/3.png": 5763,
	"./jsks/4.png": 5596,
	"./jsks/5.png": 4693,
	"./jsks/6.png": 7342,
	"./sd/1.png": 2755,
	"./sd/2.png": 8264,
	"./weight/10.png": 8080,
	"./weight/100.png": 1010,
	"./weight/20.png": 1989,
	"./weight/200.png": 241,
	"./weight/5.png": 8401,
	"./weight/50.png": 7228,
	"./weight/500.png": 4678,
	"./weight/customize.png": 3490,
	"./yuxx/1.png": 4912,
	"./yuxx/2.png": 3243,
	"./yuxx/3.png": 9026,
	"./yuxx/4.png": 1533,
	"./yuxx/5.png": 1588,
	"./yuxx/6.png": 6239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2200;